var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHANGE_CHANNEL, UPDATE_CHANNEL_LIST } from '../actions/channel.actions';
var initState = {
    currentChannel: '',
    channelList: [],
    isChannelLoaded: false,
};
export default (function (state, _a) {
    if (state === void 0) { state = initState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case CHANGE_CHANNEL:
            return __assign(__assign({}, state), { currentChannel: payload.id });
        case UPDATE_CHANNEL_LIST:
            return __assign(__assign({}, state), { channelList: payload.channelList, isChannelLoaded: true });
        default:
            return state;
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/channel.reducer.ts
// module id = 1458
// module chunks = 81